<div  mat-dialog-title>{{ title }}<div class="spacer"></div><mat-icon mat-dialog-close>close</mat-icon></div>

<mat-dialog-content>{{content}}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-stroked-button [mat-dialog-close]="false">{{secondaryButtonText}}</button>
  <button color="primary" mat-flat-button [mat-dialog-close]="true">{{primaryButtonText}}</button>
</mat-dialog-actions>